import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeLanguage } from '../constants/Languages';
import { localizeMarketingPath, parseMarketingPath } from '../constants/marketingSeo';
import { isSubdomainStoreMode } from '../utils/storeUtils';

/**
 * Returns a function that maps a language-neutral marketing path (`/privacy`) to the
 * URL for the active language (`/en/privacy`), so internal links keep the visitor in
 * their language and give crawlers the right hreflang target. Non-marketing paths and
 * store subdomains (which only serve unprefixed routes) are returned unchanged.
 */
const useLocalizedMarketingPath = () => {
  const { i18n } = useTranslation();
  const lang = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

  return useCallback(
    (path) => {
      if (isSubdomainStoreMode() || !parseMarketingPath(path).isPage) {
        return path;
      }
      return localizeMarketingPath(path, lang);
    },
    [lang]
  );
};

export default useLocalizedMarketingPath;
